import React, { useState, useEffect } from 'react';

const Popup = ({
  isOpen,
  onClose,
  title,
  message,
  instruction,
  buttonText = 'Got it',
  cancelButtonText = 'Cancel',
  showCancel = false,
  onCancel,
  onConfirm,
  icon = 'fa-triangle-exclamation',
  children,
}) => {
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setProcessing(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCancel = () => {
    if (processing) return;
    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  };

  const handleConfirm = async () => {
    if (processing) return;
    if (onConfirm) {
      setProcessing(true);
      try {
        await onConfirm();
      } catch (_) {
        // handled by caller
      } finally {
        setProcessing(false);
      }
    } else if (onClose) {
      onClose();
    }
  };

  return (
    <div className="popup-overlay" onClick={handleCancel}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-body-content">
          <div className="popup-icon-wrapper">
            <i className={`fa-solid ${icon}`}></i>
          </div>
          <h2 className="popup-title">{title}</h2>
          <p className="popup-message">{message}</p>
          {instruction && (
            <p className="popup-instruction">{instruction}</p>
          )}
          {children}
        </div>
        <div className="popup-footer">
          {showCancel && (
            <button className="popup-btn-cancel" onClick={handleCancel} disabled={processing}>
              {cancelButtonText}
            </button>
          )}
          {buttonText && (
            <button className="popup-btn-primary" onClick={handleConfirm} disabled={processing}>
              {processing ? "Processing..." : buttonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup;



